import React from 'react';
import Grid from "@material-ui/core/Grid";
import {makeStyles} from "@material-ui/core/styles";
import OSTotaisGrid from "../../../components/OSTotaisGrid";
import {useSelector} from "react-redux";
import MiniPieChart from "./MiniPieChart";
import OperadoresNaLinhaGrid from "../../../common/OperadoresNaLinhaGrid";
import useWindowDimensions from "../../../utils/windowSizeHook";


const useStyles = makeStyles(theme => ({

    gridExterno: {
        display: 'flex',
        flexDirection:'column',
        flexwrap: 'nowrap',
        flexGrow: 3,
        //backgroundColor: 'white',
        margin: '4px',
        // padding: '4px',
        borderRadius: '15px',
        minHeight: '150px',
        width: '120px',
        alignItems: 'center'


    },
    mainGrid: {
        display: 'flex',
        flexDirection:'row',
        flexwrap: 'wrap',
        flexGrow: 12,
        alignItems: 'center',
        justifyContent: 'center'
       // alignSelf: 'stretch',
    },
    linha1Grid: {
        display: 'flex',

        flexDirection:'row',
        flexwrap: 'nowrap',
        flexGrow: 12,
        alignItems: 'center',
        justifyContent: 'center'
        // alignSelf: 'stretch',
    },
    operadores: {
        display: 'flex',
        flexDirection:'column',
        flexwrap: 'wrap',
        flexGrow: 12
    },

    gridOSTotaisPortrait2: {
        display: 'flex',
        flex: '0 1 calc(50% - 8px)',
        flexDirection:'row',
        flexwrap: 'nowrap',
        flexGrow: 6,
        margin: 0,
        padding: '4px',
        borderRadius: '15px',
        minHeight: '150px',
        marginBottom:'30px',
        // width: '120px'
    },
    gridOSTotaisPortrait3: {
        display: 'flex',
        // flex: '0 1 calc(33% - 8px)',
        flexDirection:'row',
        flexwrap: 'nowrap',
        flexGrow: 4,
        margin: 0,
        padding: '4px',
        borderRadius: '15px',
        minHeight: '150px',
        marginBottom:'30px',
        // width: '120px'
    },


    gridOSTotais: {
        display: 'flex',
        flex: '0 1 calc(20% - 8px)',
       // flexDirection:'column',
        flexwrap: 'nowrap',
       // flexGrow: 3,

        margin: 0,
        padding: '4px',
        borderRadius: '15px',
        minHeight: '150px',
        marginBottom:'30px',
        // width: '120px'

    },
    operadoresGrid: {
        alignContent: 'flex-start',
        alignSelf: 'flex-start'
    }



}));

const ProducaoMensalView = () => {

    const classes= useStyles();

    const { height, width } = useWindowDimensions();
    const portrait = height > width;

    const uId =  useSelector(state => state.auth.userId);
    const demo = uId === 268;



    const pneusNaCasa = useSelector( state => state.i4.pneusNaCasa);
    const recebidosPorData = useSelector( state => state.i4.recebidosPorData);
    const enviadosPorData = useSelector( state => state.i4.enviadosPorData);
    const recapadosPorData = useSelector( state => state.i4.recapadosPorData);
    const consertadosHoje = useSelector( state => state.i4.consertadosHoje);
    const consertadosPorData = useSelector( state => state.i4.consertadosPorData);
    const retrabalhadosPorData = useSelector( state => state.i4.retrabalhadosPorData);
    const recusadosPorData = useSelector( state => state.i4.recusadosPorData);
    const reprovadosPorData = useSelector( state => state.i4.reprovadosPorData);
    const saldos = useSelector( state => state.i4.saldos);
    const tempoEtapas = useSelector(state => state.ordemServicoReducer.tempoEtapas);

    const listaOSs = useSelector( state => state.i4.listaOSs);

    const pneuMedidas = useSelector( state => state.serviceOrderStatistics.tireStatistics.tireSizes )
    const pneuBandas = useSelector( state => state.serviceOrderStatistics.tireStatistics.tireBands )

    const periodMax = useSelector( state => state.filter.periodMax );

    //console.log("concluidosPorData", concluidosPorData);

    let recebidos = 0;
    recebidosPorData.map(p => recebidos += p.quantidade);

    let recapados = 0;
    recapadosPorData.map(p => recapados += p.quantidade);

    let consertados = 0;
    consertadosPorData.map(p => consertados += p.quantidade);

    let retrabalhados = 0;
    retrabalhadosPorData.map(p => retrabalhados += p.quantidade);

    let recusados = 0;
    recusadosPorData.map(p => recusados += p.quantidade);

    let reprovados = 0;
    reprovadosPorData.map(p => reprovados += p.quantidade);

    let enviados = 0;
    enviadosPorData.map(p => enviados += p.quantidade);

    let tempoProcessamento = 0;
    tempoEtapas
        .filter(e => e.medida === "TODAS MEDIDAS-validos")
        .map(p=> tempoProcessamento += p.avgTempoSec);

    let pneusEmProducao = 0;
    pneusNaCasa
        .filter( o => [1,4,6].includes(o.statusOrdemServicoId) )
        .map( o => pneusEmProducao += 1);

    let emDesenv=0;
    const saldo = pneusNaCasa.length - recebidos + enviados;
    const totalfabrica = recapados +consertados + recusados + reprovados;
    const percRecap = (totalfabrica > 0)? (recapados*100)/totalfabrica : 0;
    const percRetrabalho = ( (recapados + consertados) > 0)? (retrabalhados*100)/ (recapados +consertados) : 0;
    const percRecusa = (totalfabrica>0)? (recusados*100)/totalfabrica : 0;
    const percReprov = (totalfabrica>0)?  (reprovados*100)/totalfabrica : 0;
    const percCons = (totalfabrica>0)?  (consertados*100)/totalfabrica : 0;

    let bandasAplicadas = [];
    let bandasTipoAplicadas = []
    listaOSs.map( (os,i) => {
            const ix = bandasAplicadas.findIndex( b => b.id === os.itemIdBandaAplicada);
            if (ix < 0) {
                bandasAplicadas.push({
                    id: os.itemIdBandaAplicada,
                    descricao: os.itemBandaAplicada,
                    quantidade: 1
                })
            } else {
                bandasAplicadas[ix].quantidade += 1;
            }

        const ixt = bandasTipoAplicadas.findIndex( b => b.descricao === os.grupoMaterialUnique);
        if (ixt < 0) {
            bandasTipoAplicadas.push({
                id: os.itemIdBandaAplicada,
                descricao: os.grupoMaterialUnique,
                quantidade: 1
            })
        } else {
            bandasTipoAplicadas[ixt].quantidade += 1;
        }


    })



    //console.log("bandasAplicadas", bandasAplicadas);
    //console.log("bandasTipoAplicadas", bandasTipoAplicadas);
    //console.log("producao mes recebidospordata", recebidosPorData)

    const dtFimHoje = periodMax.substr(0,10) >= (new Date().toISOString().substr(0,10));

        return (
            <Grid item container className={classes.gridExterno} xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container item className={classes.mainGrid} xs={12} sm={12} md={12} lg={12} xl={12}>

                    <Grid item container xs={12} sm={12} lg={12} xl={12}>

                        <Grid item container  className={classes.linha1Grid}  xs={12} sm={12} lg={12} xl={12}>

                                <Grid item container className={portrait? classes.gridOTotaisPortrait2 : classes.gridOSTotais}  sm={12} md={6} >
                                        <OSTotaisGrid dados={recapados} titulo={"RECAPADOS"} styleTitulo={ {color: 'green'}} legenda={"PNEUS"} observacao={`${(percRecap).toFixed(1)}% de ${totalfabrica}`} historico={recapadosPorData} />
                                </Grid>
                                <Grid item container className={ portrait? classes.gridOTotaisPortrait2 : classes.gridOSTotais}  style={{flexGrow:6}}  sm={12}  md={6}>
                                    <OSTotaisGrid dados={consertados} titulo={"VULCANIZADOS"} styleTitulo={ {color: 'green'}} legenda={"PNEUS"} observacao={`${(percCons).toFixed(1)}% de ${totalfabrica}`} historico={consertadosPorData} />
                                </Grid>

                                <Grid item container className={portrait? classes.gridOTotaisPortrait3 : classes.gridOSTotais}   sm={12}  md={4}>
                                        <OSTotaisGrid dados={retrabalhados} titulo={"RETRABALHADOS"} styleTitulo={ {color: '#facd1b'}} legenda={"PNEUS"}  observacao={`${percRetrabalho.toFixed(1)}% de ${(recapados +consertados)}`} historico={retrabalhadosPorData} />
                                </Grid>
                                <Grid item container className={portrait? classes.gridOTotaisPortrait3 : classes.gridOSTotais}   sm={12}  md={4}>
                                    <OSTotaisGrid dados={recusados} styleTitulo={ {color: 'red'}} titulo={"RECUSADOS"} legenda={"PNEUS"} observacao={`${percRecusa.toFixed(1)}% de ${totalfabrica}`} historico={recusadosPorData} />
                                </Grid>
                                <Grid item container className={portrait? classes.gridOTotaisPortrait3 : classes.gridOSTotais}  sm={12}  md={4}>
                                        <OSTotaisGrid dados={reprovados} styleTitulo={ {color: 'red'}} titulo={"REPROVADOS"} legenda={"PNEUS"}  observacao={`${percReprov.toFixed(1)}% de ${totalfabrica}`} historico={reprovadosPorData} />
                                </Grid>
                        </Grid>

                        <Grid item container  className={classes.linha1Grid}  xs={12} sm={12} lg={12} xl={12}>
                                <Grid item container className={portrait? classes.gridOTotaisPortrait2 : classes.gridOSTotais} xs={3} sm={3} md={3} lg={3} xl={3}>
                                    <OSTotaisGrid dados={saldos.saldoMin} titulo={"SALDO INICIO"} styleTitulo={ {color: 'green'}} legenda={"PNEUS"}  />
                                </Grid>

                                <Grid item container className={portrait? classes.gridOTotaisPortrait2 : classes.gridOSTotais} xs={3} sm={12} md={3} lg={3} xl={3}>
                                    <OSTotaisGrid dados={recebidos} titulo={"RECEBIDOS"} legenda={"PNEUS"} historico={recebidosPorData} />
                                </Grid>
                                <Grid item container className={portrait? classes.gridOTotaisPortrait2 : classes.gridOSTotais} xs={3} sm={12} md={3} lg={3} xl={3}>
                                    <OSTotaisGrid dados={enviados} titulo={"ENVIADOS"} legenda={"PNEUS"} historico={enviadosPorData} />
                                </Grid>

                                {!dtFimHoje &&
                                    <Grid item container className={portrait? classes.gridOTotaisPortrait2 : classes.gridOSTotais} xs={3} sm={12} md={3} lg={3} xl={3}>
                                        <OSTotaisGrid dados={saldos.saldoMax} titulo={"SALDO FIM"} styleTitulo={ {color: 'green'}} legenda={"PNEUS"}  />
                                    </Grid>
                                }

                            { dtFimHoje &&
                                <Grid item container className={portrait? classes.gridOTotaisPortrait2 : classes.gridOSTotais} xs={3} sm={12} md={3} lg={3} xl={3}>
                                    <OSTotaisGrid dados={pneusNaCasa} titulo={"EM CASA"}  styleTitulo={ {color: 'green'}} legenda={`PARA PRODUÇÃO: ${pneusEmProducao}`}  />
                                </Grid>
                            }

                        </Grid>
                    </Grid>

                    {/*<Grid item container className={classes.operadoresGrid} xs={3} sm={3} lg={2} xl={2}>*/}
                    {/*    /!*<OperadoresNaLinhaGrid/>*!/*/}
                    {/*</Grid>*/}


                    {/*<Grid item container className={classes.gridOSTotais} xs={3} sm={3} md={3} lg={3} xl={3}>*/}
                    {/*        <OSTotaisGrid dados={tempoProcessamento ? convertSecondsToHourMinutesFormat(tempoProcessamento) : '--'} titulo={"TEMPO PROC"} legenda={"HH:MM / PNEU"}  />*/}
                    {/*</Grid>*/}

                    {/*<Grid item container className={classes.gridOSTotais} style={{ alignContent: 'stretch', justifyContent: 'stretch'  }} xs={3} sm={3} md={3} lg={3} xl={3}>*/}
                    {/*     <MiniPieChart data={pneuBandas} dataKey="total" nameKey="banda" />*/}
                    {/*</Grid>*/}

                    {/*<Grid item container className={classes.gridOSTotais} style={{ alignContent: 'stretch', justifyContent: 'stretch'  }} xs={3} sm={3} md={3} lg={3} xl={3}>*/}
                    {/*    <MiniPieChart data={pneuMedidas} dataKey="total" nameKey="medida" />*/}
                    {/*</Grid>*/}


                </Grid>
            </Grid>



        )
    }

export default ProducaoMensalView;


